/* eslint-disable sort-keys */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Container, Loader } from 'semantic-ui-react';

import '../css/StudentAssignmentTilesView.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { ASSIGNMENT_MENU_STATUS, ASSIGNMENT_STATUS } from '../managers/AssignmentManager';
import { VIEW_SELECTION } from '../managers/NavigationManager';

const StudentAssignmentTilesView = observer((props) => {
  const { t } = props;

  const {
    appManager, assignmentManager, classroomManager, navigationManager,
    studentAssignmentManager
  } = useContext(MobXProviderContext);

  // cache each component via useMemo to avoid re-mounting on every render
  const NoAssignmentsMessage = useMemo(() => SatCoreComponent('NoAssignmentsMessage'), []);
  const StudentAssignmentPlayerLauncher = useMemo(() => SatCoreComponent('StudentAssignmentPlayerLauncher'), []);
  const StudentAssignmentTile = useMemo(() => SatCoreComponent('StudentAssignmentTile'), []);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    navigationManager.setView(VIEW_SELECTION.ASSIGNMENT_TILES);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCurrentAssignments = async () => {
    if (appManager.initializingApp) {
      return;
    }
    setLoading(true);
    const status = [ASSIGNMENT_STATUS.LOCKED, ASSIGNMENT_STATUS.READY, ASSIGNMENT_STATUS.STARTED];
    studentAssignmentManager.setCurrentStudentAssignmentMenuStatus(ASSIGNMENT_MENU_STATUS.CURRENT);
    assignmentManager.setAssignmentStatus(status);
    await assignmentManager.fetchStudentAssignments({
      classroomId: classroomManager.currentClassroomId,
      status,
      assignmentType: null,
      assignerType: null,
      clear: true,
      currentPage: 0,
      searchAll: true
    });
    setLoading(false);
  };

  useEffect(() => {
    fetchCurrentAssignments();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Note: player-close refetch is handled centrally by StudentAssignmentPlayerLauncherService.closeActivePlayer.
  // TODO remove
  // // Refetch when a player modal closes so tile state reflects any progress
  // // the student made during the launch (status, submitted, etc.).
  // const { activePlayer } = studentAssignmentPlayerLauncherManager;
  // const prevActivePlayer = useRef(activePlayer);
  // useEffect(() => {
  //   if (prevActivePlayer.current && !activePlayer) {
  //     fetchCurrentAssignments();
  //   }
  //   prevActivePlayer.current = activePlayer;
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [activePlayer]);

  const isLoading = (!assignmentManager.loaded && classroomManager.currentClassroomId) || loading;
  const hasAssignments = assignmentManager.assignmentArray.length > 0;
  const showLoader = isLoading && !hasAssignments;

  const renderStudentAssignmentTilesView = () => {
    return (
      <>
        <Container className='StudentAssignmentTilesView' fluid>
          <h1 className='sr-only page-heading'>{t('AssignmentLabel')}</h1>
          {showLoader ? <Loader active /> : renderStudentAssignmentTiles()}
        </Container>
        <StudentAssignmentPlayerLauncher />
      </>
    );
  };

  const renderStudentAssignmentTiles = () => {
    if (!hasAssignments) {
      return (
        <div className='student-assignment-tiles-empty'>
          <NoAssignmentsMessage message={t('NoCurrentAssignments')} />
        </div>
      );
    }
    return (
      <div className='student-assignment-tiles'>
        {assignmentManager.assignmentArray.map((assignment) => (
          <StudentAssignmentTile
            key={`StudentAssignmentTile_${assignment.id}`}
            assignment={assignment}
            menuStatus={ASSIGNMENT_MENU_STATUS.CURRENT} />
        ))}
      </div>
    );
  };

  return renderStudentAssignmentTilesView();
});
export default StudentAssignmentTilesView;

SatCoreRegister('StudentAssignmentTilesView', StudentAssignmentTilesView);
